// extracted by mini-css-extract-plugin
export default {"three-sheep-bg":"wechat_three-sheep-bg__PExGv","qrcode":"wechat_qrcode__ORo0o","finger":"wechat_finger__kyju9","fingerHandle":"wechat_fingerHandle__pa6i+"};